import firebase from 'firebase'
import firestore from 'firebase/firestore'

// Your web app's Firebase configuration
var firebaseConfig = {
  apiKey: "AIzaSyCCIwggtMjSH6TPmaa7m7sYcLel-9vrT3s",
  authDomain: "gh-init.firebaseapp.com",
  databaseURL: "https://gh-init.firebaseio.com",
  projectId: "gh-init",
  storageBucket: "gh-init.appspot.com",
  messagingSenderId: "80189805845",
  appId: "1:80189805845:web:2de7f717413aa59dae051c"
};
// Initialize Firebase
const firebaseApp = firebase.initializeApp(firebaseConfig);

export default firebaseApp.firestore()



// WEBPACK FOOTER //
// ./src/firebase/init.js